import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bath_decor: FaireCategoryEntity = {
  token: "cat_bath-decor",
  type: "category",
  name: "Bath decor",
  level: 3,
  parentToken: "cat_home-decor-bath",
  href: "/category/home-decor/bath/bath-decor",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
